module.exports = __webpack_public_path__ + "static/img/CModelIMG2.b2d9014.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/CModelIMG2.png
// module id = k6rY
// module chunks = 1